export const lenisRef = { current: null };

export const scrollToSection = (hash) => {
  if (lenisRef.current) {
    lenisRef.current.scrollTo(hash, { offset: -70, duration: 1.3 });
  } else {
    document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
  }
};
